import Swal from 'sweetalert2';

// Custom SweetAlert2 configuration matching admin panel theme
const swalConfig = {
  customClass: {
    popup: 'custom-swal-popup',
    title: 'custom-swal-title',
    content: 'custom-swal-content',
    confirmButton: 'custom-swal-confirm',
    cancelButton: 'custom-swal-cancel',
    denyButton: 'custom-swal-deny',
  },
  buttonsStyling: false,
};

// Success Alert
export const showSuccess = (title: string, text?: string) => {
  return Swal.fire({
    ...swalConfig,
    icon: 'success',
    title,
    text,
    confirmButtonText: 'OK',
  });
};

// Error Alert
export const showError = (title: string, text?: string) => {
  return Swal.fire({
    ...swalConfig,
    icon: 'error',
    title,
    text,
    confirmButtonText: 'OK',
  });
};

// Warning Alert
export const showWarning = (title: string, text?: string) => {
  return Swal.fire({
    ...swalConfig,
    icon: 'warning',
    title,
    text,
    confirmButtonText: 'OK',
  });
};

// Info Alert
export const showInfo = (title: string, text?: string) => {
  return Swal.fire({
    ...swalConfig,
    icon: 'info',
    title,
    text,
    confirmButtonText: 'OK',
  });
};

// Confirmation Dialog
export const showConfirm = (
  title: string,
  text?: string,
  confirmButtonText = 'Yes, proceed!',
  cancelButtonText = 'Cancel'
) => {
  return Swal.fire({
    ...swalConfig,
    icon: 'question',
    title,
    text,
    showCancelButton: true,
    confirmButtonText,
    cancelButtonText,
  });
};

// Delete Confirmation (special styling for dangerous actions)
export const showDeleteConfirm = (
  title: string,
  text?: string,
  confirmButtonText = 'Yes, delete it!',
  cancelButtonText = 'Cancel'
) => {
  return Swal.fire({
    ...swalConfig,
    icon: 'warning',
    title,
    text,
    showCancelButton: true,
    confirmButtonText,
    cancelButtonText,
    customClass: {
      ...swalConfig.customClass,
      confirmButton: 'custom-swal-confirm-danger',
    },
  });
};

// Loading Alert
export const showLoading = (title: string, text?: string) => {
  return Swal.fire({
    ...swalConfig,
    title,
    text,
    allowOutsideClick: false,
    allowEscapeKey: false,
    allowEnterKey: false,
    showConfirmButton: false,
    didOpen: () => {
      Swal.showLoading();
    },
  });
};

// Close any open alert
export const closeAlert = () => {
  Swal.close();
};

// Toast notification (small, non-intrusive)
export const showToast = (
  icon: 'success' | 'error' | 'warning' | 'info',
  title: string,
  timer = 3000
) => {
  return Swal.fire({
    toast: true,
    position: 'top-end',
    icon,
    title,
    showConfirmButton: false,
    timer,
    timerProgressBar: true,
    customClass: {
      popup: 'custom-swal-toast',
    },
  });
};

// Input Dialog
export const showInput = (
  title: string,
  placeholder?: string,
  inputValue?: string,
  confirmButtonText = 'Submit'
) => {
  return Swal.fire({
    ...swalConfig,
    title,
    input: 'text',
    inputPlaceholder: placeholder,
    inputValue,
    showCancelButton: true,
    confirmButtonText,
    cancelButtonText: 'Cancel',
    inputValidator: (value) => {
      if (!value || value.trim() === '') {
        return 'Please enter a value';
      }
      return null;
    },
  });
};